/**
 * Maps key for the public venue-admin registration form.
 *
 * getPortalApiKey requires a signed-in portal role, so this form must not
 * call it. The value is the browser key (restrict it by HTTP referrer).
 * Signed-in portal screens load their key with getPortalApiKey directly.
 */
class ConfigService {
  private static instance: ConfigService;
  private googleApiKey: string | null = null;
  private keysLoaded: boolean = false;
  private loadingPromise: Promise<void> | null = null;

  private constructor() {}

  static getInstance(): ConfigService {
    if (!ConfigService.instance) {
      ConfigService.instance = new ConfigService();
    }
    return ConfigService.instance;
  }

  async initialize(): Promise<void> {
    if (this.loadingPromise) {
      return this.loadingPromise;
    }

    if (this.keysLoaded) {
      return Promise.resolve();
    }

    this.loadingPromise = this.loadPublicMapsKey();
    return this.loadingPromise;
  }

  private async loadPublicMapsKey(): Promise<void> {
    try {
      const key = process.env.REACT_APP_GOOGLE_API_KEY?.trim();
      if (!key) {
        throw new Error('REACT_APP_GOOGLE_API_KEY is not set');
      }
      this.googleApiKey = key;
      this.keysLoaded = true;
    } finally {
      this.loadingPromise = null;
    }
  }

  getGoogleApiKey(): string {
    if (!this.keysLoaded || !this.googleApiKey) {
      throw new Error('Config not initialized. Call initialize() first.');
    }
    return this.googleApiKey;
  }

  isReady(): boolean {
    return this.keysLoaded && this.googleApiKey !== null;
  }
}

export const configService = ConfigService.getInstance();
